import { render, staticRenderFns } from "./GapPatientLogin.vue?vue&type=template&id=c5adf4b2&scoped=true&"
import script from "./GapPatientLogin.vue?vue&type=script&lang=ts&"
export * from "./GapPatientLogin.vue?vue&type=script&lang=ts&"
import style0 from "./GapPatientLogin.vue?vue&type=style&index=0&id=c5adf4b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5adf4b2",
  null
  
)

export default component.exports